import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-1 bg-white p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-warmgray-600 mr-2 text-lg" }, "camera_alt"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-warmgray-600 text-sm font-bold" }, "ログイン")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-warmgray-600 mr-2 text-lg" }, "camera_alt"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-warmgray-600 text-sm font-bold" }, "マイページ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-warmgray-600 mr-2 text-lg" }, "lens"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-warmgray-600 text-sm font-bold" }, "Top")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-warmgray-600 mr-2 text-lg" }, "lens"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-warmgray-600 text-sm font-bold" }, "Makers")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-warmgray-600 mr-2 text-lg" }, "lens"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-warmgray-600 text-sm font-bold" }, "ログアウト")
], -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.store.state.user)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "flex items-center rounded-lg bg-gray-200 px-4 py-2",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
        }, [
          _createVNode(_component_router_link, {
            to: _ctx.localizedUrl('/account')
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.store.state.user)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "flex items-center rounded-lg bg-gray-200 px-4 py-2",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
        }, [
          _createVNode(_component_router_link, {
            to: _ctx.localizedUrl('/mypage')
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "flex items-center rounded-lg bg-gray-200 px-4 py-2",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
    }, [
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/')
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", {
      class: "flex items-center rounded-lg bg-gray-200 px-4 py-2",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
    }, [
      _createVNode(_component_router_link, {
        to: _ctx.localizedUrl('/lenses/makers')
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", {
      class: "flex items-center rounded-lg bg-gray-200 px-4 py-2",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
    }, _hoisted_7)
  ]))
}